import { Ref } from '@nuxtjs/composition-api';

// import IBiuro from '~/components/biura/types/IBiuro';
import IBiuroSzczegoly from '~/components/biura/types/IBiuroSzczegoly';
import { IRouteInfo } from '~/types/IRouteInfo';

import IBiuraSzczegolyJsonLd from '../types/IBiuraSzczegolyJsonLd';

interface IBiuroSzczegolyJsonLdParams {
  biuroRef: Ref<IBiuroSzczegoly | null>;
  routeInfoRef: Ref<IRouteInfo>;
  host: string;
}

const buildJsonLdForBiuraSzczegoly = (params: IBiuroSzczegolyJsonLdParams): IBiuraSzczegolyJsonLd | null => {
  const { biuroRef, routeInfoRef, host } = params;
  const biuro = biuroRef.value;

  if (!biuro) return null;

  const routeInfo = routeInfoRef.value?.Route;

  const result: IBiuraSzczegolyJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'TravelAgency',
    name: biuro.Nazwa,
    image: biuro.Zdjecia?.length ? `https:${biuro.Zdjecia[0]}` : '',
    url: `${host}${routeInfo}`,
    telephone: biuro.Telefony?.length ? biuro.Telefony[0] : '',
    address: {
      '@type': 'PostalAddress',
      streetAddress: biuro.Ulica,
      addressLocality: biuro.Miasto,
      postalCode: biuro.KodPocztowy,
      addressCountry: 'PL',
    },
  };

  result.geo = biuro.SzerokoscGeo !== undefined && biuro.SzerokoscGeo !== null && biuro.DlugoscGeo !== undefined && biuro.DlugoscGeo !== null
    ? {
      '@type': 'GeoCoordinates',
      latitude: biuro.SzerokoscGeo,
      longitude: biuro.DlugoscGeo,
    }
    : result.geo;

  return result;
};
export default buildJsonLdForBiuraSzczegoly;
